<footer class="footer-area" id="footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-footer-widget">
          <a routerLink="/" class="logo"><img src="assets/images/logo_thmp.png" alt="logo" style="height: 40px;"></a>
          <p>THMP - Monitoring </p>
          <!-- <ul class="social-link">
            <li><a href="#" class="d-block" target="_blank"><i class='ci ci-logo-facebook'></i></a></li>
            <li><a href="#" class="d-block" target="_blank"><i class='ci ci-logo-twitter'></i></a></li>
          </ul> -->
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6">
        <div class="single-footer-widget">
          <ul class="footer-contact-info">
            <li><i class='ci ci-home'></i>Công ty Cổ phần Đầu tư và Công nghệ Tân Hoàng Minh Phát</li>
            <li><i class='ci ci-map'></i> Tầng 8, tòa nhà CIC, số 8 ngõ 219 phố Trung Kính, phường Yên Hòa, thành phố Hà
              Nội.
            </li>
            <li><i class='ci ci-phone'></i><a href="tel:024 66 59 44 00">024 66 59 44 00</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-bottom-area">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-6">
          <p><i class='ci ci-at'></i>2024 THMP </p>
        </div>
        <div class="col-lg-6 col-md-6">
          <!-- <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                        <li><a routerLink="/terms-of-service">Terms & Conditions</a></li>
                    </ul> -->
        </div>
      </div>
    </div>
  </div>
  <div class="lines">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</footer>